import React from "react";
import "./All_Projects.css";
import Service_Banner from "../services/service_common_components/service_banner/Service_Banner";
import { Nav, Tab } from "react-bootstrap";
import All_Tab from "./all_tab/All_Tab";

const All_Projects = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Projects", link: "", isActive: true },
  ];

  return (
    <section className="All_Projects">
      <Service_Banner
        imgSrc={"/assets/images/services/banners/residential.png"}
        title_text="PROJECTS"
        breadcrumbs={breadcrumbs}
      />

      <div className="container">
        <Tab.Container id="left-tabs-example" defaultActiveKey="All">
          <Nav variant="pills" className="d-flex">
            <Nav.Item>
              <Nav.Link eventKey="All">All</Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
              <Nav.Link eventKey="Residential">Residential</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Commercial">Commercial</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Industrial">Industrial</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="Corporate">Corporate</Nav.Link>
            </Nav.Item> */}
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="All">
              <All_Tab />
            </Tab.Pane>

            {/* <Tab.Pane eventKey="Residential">
              <All_Tab />
            </Tab.Pane>
            <Tab.Pane eventKey="Commercial">
              <All_Tab />
            </Tab.Pane>
            <Tab.Pane eventKey="Industrial">
              <All_Tab />
            </Tab.Pane>
            <Tab.Pane eventKey="Corporate">
              <All_Tab />
            </Tab.Pane> */}

          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default All_Projects;
